import type {} from '@angular/localize/init';
import { appRoutesI18nCache } from '../i18n-cache';

export function virtualSportsRouteI18n(): string {
  return (appRoutesI18nCache['virtual-sports'] ??= $localize`:url-segment@@virtual-sports-url-segment:virtual-sports`);
}
